export const sliderStyles = {
  algoprimary: {
    thumb: 'bg-white border-borderInversePrimary',
    range: 'bg-backgroundInversePrimary',
    track: 'bg-backgroundBlue'
  },

  difficulty_1_29: {
    thumb: '',
    range: 'bg-contentEmerald',
    track: 'bg-backgroundEmerald'
  },
  difficulty_30_39: {
    thumb: '',
    range: 'bg-contentTeal',
    track: 'bg-backgroundTeal'
  },
  difficulty_40_49: {
    thumb: '',
    range: 'bg-contentCyan',
    track: 'bg-backgroundCyan'
  },
  difficulty_50_59: {
    thumb: '',
    range: 'bg-contentSky',
    track: 'bg-backgroundSky'
  },
  difficulty_60_69: {
    thumb: '',
    range: 'bg-contentBlue',
    track: 'bg-backgroundBlue'
  },
  difficulty_70_79: {
    thumb: '',
    range: 'bg-contentIndigo',
    track: 'bg-backgroundIndigo'
  },
  difficulty_80_89: {
    thumb: '',
    range: 'bg-contentViolet',
    track: 'bg-backgroundViolet'
  },
  difficulty_90_99: {
    thumb: '',
    range: 'bg-contentPurple',
    track: 'bg-backgroundPurple'
  },
  difficulty_100: {
    thumb: '',
    range: 'bg-contentFuchsia',
    track: 'bg-backgroundFuchsia'
  },
  quality_0_29: {
    thumb: '',
    range: 'bg-contentRose',
    track: 'bg-backgroundRose'
  },
  quality_30_39: {
    thumb: '',
    range: 'bg-contentRed',
    track: 'bg-backgroundRed'
  },
  quality_40_49: {
    thumb: '',
    range: 'bg-contentOrange',
    track: 'bg-backgroundOrange'
  },
  quality_50_59: {
    thumb: '',
    range: 'bg-contentAmber',
    track: 'bg-backgroundAmber'
  },
  quality_60_69: {
    thumb: '',
    range: 'bg-contentYellow',
    track: 'bg-backgroundYellow'
  },
  quality_70_79: {
    thumb: '',
    range: 'bg-contentLime',
    track: 'bg-backgroundLime'
  },
  quality_80_89: {
    thumb: '',
    range: 'bg-contentGreen',
    track: 'bg-backgroundGreen'
  },
  quality_90_99: {
    thumb: '',
    range: 'bg-contentEmerald',
    track: 'bg-backgroundEmerald'
  },
  quality_100: {
    thumb: '',
    range: 'bg-contentTeal',
    track: 'bg-backgroundTeal'
  }
}
